var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container ask"},[_c('NormalHeader',{attrs:{"languageBtn":true}}),_c('div',{staticClass:"conts"},[_c('div',{staticClass:"wapper"},[_c('h2',[_vm._v(_vm._s(_vm.$t('출입등록')))]),_c('blockquote',{domProps:{"innerHTML":_vm._s(
          _vm.$t(
            '안녕하세요_출입등록을_위해서는_아래_개인정보_및_민감정보_수집_내용을_확인하고_동의해야_합니다'
          )
        )}}),_c('AgreeTerms',{ref:"terms",on:{"input":_vm.checkNext}})],1),_c('div',{staticClass:"btn_area"},[_c('div',{staticClass:"btn",class:{ disabled: !_vm.canNext },on:{"click":_vm.submit}},[_vm._v(" "+_vm._s(_vm.$t('확_인'))+" ")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }